import { css } from "@stubhub/broadway-foundation/css";

// TitleSection
export const titleSectionStyles = {
  container: css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.100",
    columnGap: "primitives.100",
    paddingBlockStart: "primitives.200",
    paddingBlockEnd: "primitives.150",
    paddingInline: "primitives.200",
    backgroundColor: "bg.surface",
    borderStartEndRadius: "primitives.150",
    borderStartStartRadius: "primitives.150",
  }),
  actionsButton: css({
    position: "absolute",
    insetBlockStart: "primitives.100",
    insetInlineEnd: "primitives.100",
  }),
  innerRow: css({
    display: "flex",
    columnGap: "primitives.100",
    rowGap: "primitives.100",
    alignItems: "start",
    width: "full",
    paddingInlineEnd: "primitives.500",
  }),
  image: css({
    width: "[93px]",
    height: "[93px]",
    borderStartStartRadius: "[12px]",
    borderStartEndRadius: "[12px]",
    borderEndStartRadius: "[12px]",
    borderEndEndRadius: "[12px]",
    objectFit: "cover",
    flexShrink: 0,
  }),
  textColumn: css({
    display: "flex",
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: "[0]",
    flexDirection: "column",
    columnGap: "primitives.100",
    rowGap: "primitives.100",
    alignItems: "start",
    minWidth: "[1px]",
    alignSelf: "stretch",
  }),
  badgeRow: css({
    display: "flex",
    columnGap: "primitives.100",
    rowGap: "primitives.100",
    alignItems: "center",
    overflowX: "hidden",
    overflowY: "hidden",
  }),
};

export const filterBarRow = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  columnGap: "primitives.100",
  paddingBlockStart: "primitives.50",
  paddingBlockEnd: "primitives.150",
});

// FilterBar — wraps filterRow from the tablet styles and adds horizontal page padding
export const filterBarContainer = css({
  paddingInline: "primitives.200",
  backgroundColor: "bg.surface",
  borderBlockEndWidth: "primitives.25",
  borderBlockEndStyle: "solid",
  borderBlockEndColor: "border",
  borderEndStartRadius: "primitives.150",
  borderEndEndRadius: "primitives.150",
  overflowX: "auto",
});

// ShowsAvailableCount
export const showsAvailableCountStyles = {
  container: css({
    paddingInlineEnd: "primitives.200",
    paddingInlineStart: "primitives.200",
    paddingBlockStart: "primitives.250",
    paddingBlockEnd: "primitives.100",
  }),
};

// CrossSellSection
export const crossSellStyles = {
  outerClip: css({
    overflowX: "hidden",
    paddingBlockStart: "primitives.200",
  }),
  innerScroll: css({
    display: "flex",
    flexDirection: "row",
    rowGap: "primitives.150",
    columnGap: "primitives.150",
    overflowX: "auto",
    scrollSnapType: "[x mandatory]",
    paddingInline: "primitives.200",
    paddingBlockEnd: "primitives.200",
  }),
  card: css({
    flexShrink: 0,
    scrollSnapAlign: "start",
    width: "[240px]",
  }),
};

// ResidencyMobileEmptyState
export const emptyStateStyles = {
  container: css({
    paddingInline: "primitives.200",
    paddingBlockStart: "primitives.250",
    paddingBlockEnd: "primitives.200",
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.150",
  }),
  button: css({
    width: "full",
  }),
};

// Top-level residency wrapper
export const residencyCalendarContainer = css({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "bg.surface",
});
